import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map, take } from 'rxjs';
import { UserType } from '@app/core/api/auth/auth.enum';
import { AuthService } from '@app/core/services/auth.service';

function matchTypes(...types: UserType[]): CanMatchFn {
  return () =>
    inject(AuthService).currentUser$.pipe(
      take(1),
      map((user) => !!user?.type && types.includes(user.type as UserType))
    );
}

export const matchAdmin: CanMatchFn = matchTypes(UserType.Admin);
export const matchSales: CanMatchFn = matchTypes(UserType.Sales);
export const matchConcierge: CanMatchFn = matchTypes(UserType.Concierge);
export const matchCompany: CanMatchFn = matchTypes(
  UserType.CompanyOwner,
  UserType.CompanyStaff
);
export const matchExpert: CanMatchFn = matchTypes(UserType.Expert);
